<template>
	<div class="item">
		<a class="link" @click="active = true">
			<div class="image" v-if="img">
				<img :src="img"/>
			</div>

			<div class="content">
				<div class="header">
					<div class="title" v-text="title"/>
					<div class="seen" v-if="visited">
						Set <div class="icon" v-html="require('@/assets/icons/check.svg')"/>
					</div>
				</div>

				<div class="date" v-text="date"/>
				<div class="sub" v-text="subtitle"/>
			</div>
		</a>

		<modal v-if="active" v-bind="{slug}" @close="active = false"/>
	</div>
</template>

<script>
import {date} from "@/modules/utils";
import modal from "../item-modal.vue";

export default {
	components: {modal},
	props: {
		id: {type: Number, required: true},
		slug: {type: String, required: true},
		title: {type: String, required: true},
		image: {type: Object, required: false},
		visited: {type: Boolean, required: true},
		subtitle: {type: String, required: true},
		published_at: {type: Number, required: true}
	},
	data() {
		return {
			active: false
		}
	},
	computed: {
		img: (t) => t.image ? t.image.url : null,
		date: (t) => `— ${date(t.published_at).string}`
	}
};
</script>

<style lang="scss" scoped>
.item {
	width: calc(50% - 21px);
	background-color: $white1;

	@include res(tablet) {
		width: 100%;
		&:first-child {
			margin-bottom: 20px;
		}
	}

	@include res(mobile) {
		&:first-child {
			margin-bottom: 13px;
		}
	}

	.link {
		box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.25);
		display: flex;
		height: 100%;
	}

	.image {
		flex-shrink: 0;

		@include res(mobile) {
			display: none;
		}

		img {
			display: block;
			object-fit: cover;
			width: 130px;
			height: 100%;
		}
	}

	.content {
		width: 100%;
		padding: 25px;

		.header {
			display: flex;
			justify-content: space-between;

			.title {
				font-size: 16px;
				font-weight: 700;
				margin-bottom: 10px;
			}

			.seen {
				display: flex;
				align-items: center;
				font-size: 18px;
				font-weight: 300;
				color: #3C9195;

				.icon {
					margin-left: 0.2em;

					/deep/ svg {
						$s: 16px;
						width: $s;
						height: $s;

						path {
							fill: #3C9195;
						}
					}
				}
			}
		}

		.date {
			font-size: 14px;
			font-weight: 300;
			color: #B1B1B1;
			letter-spacing: 0.08px;
			margin-bottom: 24px;
		}

		.sub {
			font-size: 14px;
			color: #182E38;
		}
	}
}
</style>
